import AppMainMenu from './app-main-menu';

export default AppMainMenu;
